(function (){
    'use strict';

    angular
        .module('services')
        .service('PlatformRentalService', PlatformRentalService);

    PlatformRentalService.$inject = ['$http', 'API_BASE'];

    function PlatformRentalService ($http, API_BASE) {
        
        var service = this;
        service.getVirtualFairs = getVirtualFairs;
        service.getPhysicalFairs = getPhysicalFairs;
        service.getPlatformRentals = getPlatformRentals;
        service.getPlatformRental = getPlatformRental;
        service.storePlatformRental = storePlatformRental;
        service.updatePlatformRental = updatePlatformRental;
        service.deletePlatformRental = deletePlatformRental;
        service.sendPassword = sendPassword;
        service.scheduleReport = scheduleReport;
        service.getPostNetworkingEvents = getPostNetworkingEvents;
        service.getNumberOfVisitors = getNumberOfVisitors;
        service.getByAge = getByAge;
        service.getByCourseOfInterest = getByCourseOfInterest;
        service.getWhereWhantStudy = getWhereWhantStudy;

        function getVirtualFairs (platformRental = false, query = {}) {
            if(platformRental) {
                query['platform-rental'] = 1;
            }
            return $http.get(API_BASE + '/platform-rental/virtualfairs', {params: query});
        }

        function getPhysicalFairs (platformRental = false, query = {}) {
            if(platformRental) {
                query['platform-rental'] = 1;
            }
            return $http.get(API_BASE + '/platform-rental/physicalfairs', {params: query});
        }
        
        function getPlatformRentals (data) {
            return $http.get(API_BASE + '/platform-rental/list', {params: data});
        }

        function getPlatformRental (id) {
            return $http.get(API_BASE + '/platform-rental/' + id);
        }

        function storePlatformRental(data) {
            return $http.post(API_BASE + '/platform-rental/', data);
        }

        function updatePlatformRental(id, data) {
            return $http.post(API_BASE + '/platform-rental/' + id, data);
        }

        function deletePlatformRental(id, data) {
            return $http.delete(API_BASE + '/platform-rental/' + id, data);
        }

        function sendPassword(id) {
            return $http.post(API_BASE + '/platform-rental/'+id+'/send-password');
        }

        function scheduleReport(id, data) {
            return $http.post(API_BASE + '/platform-rental/'+id+'/schedule-report', data);
        }

        function getPostNetworkingEvents(platformRental = false) {
            return $http.get(API_BASE + '/platform-rental/networking-events/post' + (platformRental ? '?platform-rental=1' : ''));
        }

        function getNumberOfVisitors (data) {
            return $http.get(API_BASE + '/platform-rental/general-statistics/total-number-visitors', {params: data});
        }

        function getByAge (data) {
            return $http.get(API_BASE + '/platform-rental/general-statistics/total-age', {params: data});
        }

        function getByCourseOfInterest (data) {
            return $http.get(API_BASE + '/platform-rental/general-statistics/total-course-interest', {params: data});
        }

        function getWhereWhantStudy (data) {
            return $http.get(API_BASE + '/platform-rental/general-statistics/where-want-study', {params: data});
        }
    }
})();